import * as angular from 'angular';
import AuthService from './auth.service';
import ModalService from '../utils/modal/modal.service';

export default angular
  .module('CrazyWeb.Auth', [])
  .service('AuthService', AuthService)
  .service('ModalService', ModalService)
  .config([
    '$stateProvider',
    $stateProvider => {
      $stateProvider
        .state('login', {
          url: '/login',
          controller: [
            'AuthService',
            function(AuthService) {
              return AuthService.login();
            }
          ]
        })
        .state('logout', {
          url: '/logout',
          controller: [
            'AuthService',
            function(AuthService) {
              return AuthService.logout();
            }
          ]
        });
    }
  ]).name;
